import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

function Footer() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (event) => {
    event.preventDefault();
    if (!email.trim()) return;
    setSubscribed(true);
    setEmail("");
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <section className="footer-newsletter" aria-labelledby="newsletter-title">
        <div>
          <p className="eyebrow">Letters from the coast</p>
          <h2 id="newsletter-title">Sea you soon.</h2>
        </div>
        <div className="footer-newsletter__form-wrap">
          <p>Stories, thoughtful releases and 10% off your first order.</p>
          <form onSubmit={handleSubscribe}>
            <label className="sr-only" htmlFor="footer-email">Email address</label>
            <input
              id="footer-email"
              type="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="Email address"
            />
            <button type="submit" aria-label="Subscribe">→</button>
          </form>
          {subscribed && <p className="footer-newsletter__success" role="status">You are on the list. Welcome aboard.</p>}
        </div>
      </section>

      <div className="footer-main">
        <div className="footer-brand">
          <Link className="footer-wordmark" to="/">
            <span>{siteConfig.logo.symbol}</span>
            {siteConfig.logo.wordmark}
          </Link>
          <p>{siteConfig.description}</p>
        </div>

        <div className="footer-links">
          <div>
            <h3>Shop</h3>
            <Link to="/shop?collection=women">Women</Link>
            <Link to="/shop?collection=men">Men</Link>
            <Link to="/shop?status=new-in">New in</Link>
            <Link to="/shop?status=sale">Sale</Link>
          </div>
          <div>
            <h3>Help</h3>
            <Link to="/contact">Contact</Link>
            <Link to="/shipping">Shipping</Link>
            <Link to="/returns">Returns</Link>
            <Link to="/cartpage">Shopping bag</Link>
          </div>
          <div>
            <h3>About</h3>
            <Link to="/about">Our story</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
          <div>
            <h3>Follow</h3>
            <a href={siteConfig.social.instagram} target="_blank" rel="noreferrer">Instagram <FiArrowUpRight /></a>
            <a href={siteConfig.social.pinterest} target="_blank" rel="noreferrer">Pinterest <FiArrowUpRight /></a>
            <a href={siteConfig.social.facebook} target="_blank" rel="noreferrer">Facebook <FiArrowUpRight /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} {siteConfig.brandName}</span>
        <span>{siteConfig.commerce.currency} · English</span>
        <span>Made with respect for people and the ocean.</span>
      </div>
    </footer>
  );
}

export default Footer;
